<template>
   <div>  
        <span class="paging_details">Showing ({{(this.page * this.itemsPerPage) + 1}} to {{(this.itemsPerPage * (this.page + 1)) >= this.maxiumumItems ? this.maxiumumItems : (this.itemsPerPage * (page + 1))}}) of {{this.maxiumumItems}} requests</span>

      <nav v-if="!(maxiumumItems <= itemsPerPage)" aria-label="Page navigation example">
        <ul class="pagination justify-content-center">
          <li class="page-item" v-bind:class="{ disabled: page == 0 }">
            <a
              @click="updatePage(page - 1)"
              class="page-link clickable"
              tabindex="-1"
              >Previous</a
            >
          </li>
          <li class="page-item" v-bind:class="{ invisible: page < 3 }">
            <a @click="updatePage(0)" class="page-link clickable">1</a>
          </li>
          <li class="page-item" v-bind:class="{ invisible: page < 2 }">
            <a @click="updatePage(page - 2)" class="page-link clickable">{{
              page - 1
            }}</a>
          </li>
          <li class="page-item" v-bind:class="{ invisible: page < 1 }">
            <a @click="updatePage(page - 1)" class="page-link clickable">{{
              page
            }}</a>
          </li>
          <li class="page-item bg-primary">
            <a
              @click="updatePage(page)"
              class="page-link selected-page clickable"
              >{{ page + 1 }}</a
            >
          </li>
          <li v-if="page + 2 < maxPages" class="page-item">
            <a @click="updatePage(page + 1)" class="page-link clickable">{{
              page + 2
            }}</a>
          </li>
          <li v-if="page + 3 < maxPages" class="page-item">
            <a @click="updatePage(page + 2)" class="page-link clickable">{{
              page + 3
            }}</a>
          </li>
          <li
            class="page-item"
            v-bind:class="{ invisible: maxPages == page + 1 }"
          >
            <a @click="updatePage(maxPages - 1)" class="page-link clickable">{{
              Math.ceil(maxPages)
            }}</a>
          </li>
          <li
            class="page-item"
            v-bind:class="{ disabled: maxPages == page + 1 }"
          >
            <a class="page-link clickable" @click="updatePage(page + 1)"
              >Next</a
            >
          </li>
        </ul>
      </nav>
      </div>
</template>

<script>
export default {
  name: "BulkRequestDescription",
  model: {
    prop: 'description',
    event: 'change'
  },
  props: {
    page: Number,
    itemsPerPage: Number,
    maxiumumItems: Number,
    updatePage: Function
  },
  computed: {
    maxPages() {
      const vals = this.maxiumumItems;
      var val = Math.ceil(vals / this.itemsPerPage);
      return val;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>